// メンテナンスモードかどうか
export enum Mode {
  App,
  Maintenance,
}
